(function () {
    let updateTimeout = null;
    const DEBOUNCE_DELAY = 1500;

    function getUpdateButton() {
        const cartForm = document.querySelector('.woocommerce-cart-form');
        return cartForm ? cartForm.querySelector('button[name="update_cart"]') : null;
    }

    function isCartQuantityInput(element) {
        if (!element || !element.classList.contains('qty')) {
            return false;
        }
        const cartForm = element.closest('.woocommerce-cart-form');
        return cartForm !== null;
    }

    function triggerCartUpdate() {
        const updateButton = getUpdateButton();
        if (updateButton) {
            updateButton.removeAttribute('disabled');
            updateButton.click();
        }
    }

    function debounceUpdate() {
        if (updateTimeout) {
            clearTimeout(updateTimeout);
        }

        updateTimeout = setTimeout(() => {
            triggerCartUpdate();
        }, DEBOUNCE_DELAY);
    }

    function handleQuantityInput(e) {
        if (isCartQuantityInput(e.target)) {
            debounceUpdate();
        }
    }

    function handleQuantityBlur(e) {
        if (isCartQuantityInput(e.target)) {
            if (updateTimeout) {
                clearTimeout(updateTimeout);
            }
            triggerCartUpdate();
        }
    }

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('qty-plus') || e.target.classList.contains('qty-minus')) {
            const input = e.target.parentElement.querySelector('input.qty');
            if (input) {
                if (e.target.classList.contains('qty-plus')) {
                    input.stepUp();
                } else {
                    input.stepDown();
                }

                input.dispatchEvent(new Event('change', { bubbles: true }));
                triggerCartUpdate();
            }
        }
    });

    document.addEventListener('input', handleQuantityInput, true);
    document.addEventListener('blur', handleQuantityBlur, true);

    document.addEventListener('updated_wc_div', function () {
        if (updateTimeout) {
            clearTimeout(updateTimeout);
        }
    });

    document.addEventListener('updated_cart_totals', function () {
        if (updateTimeout) {
            clearTimeout(updateTimeout);
        }
    });
})();

